var thresholdWidth = 992;

$(document).ready(function () {
  // Hide searchPanel on click outside
  $('body').click(function (e) {
    if (!$(e.target).closest(".toggle-search").length && !$(e.target).closest(".searchPanel").length) {
      $("nav.navbar-default").removeClass("search-open");
    }

    $("input.toggle").prop("checked", "");
    if (!$(e.target).closest(".redesign-search").length) {
      $("nav.menu-redesign").removeClass("search-open");
    }
  });

  // Do not close footer and search panel when they are clicked
  $(".service, .information, .steuerbuch, .redesign-searchPanel").click(function (e) {
    e.stopPropagation();
  });

  // Bootstrap collapsible menu ( main navigation )
  $(".collapse").on('show.bs.collapse', function (e) {
    if ($('#fon-menu').hasClass("in")) {
      $('#fon-menu').addClass("hide");
    }
    if ($('#fon-user-menu').hasClass("in")) {
      $('#fon-user-menu').addClass("hide");
    }
    $(".menu-redesign .collapse").not(e.target).collapse("hide");
  });

  $(".collapse").on('hidden.bs.collapse', function () {
    $('#fon-menu').removeClass("hide");
    $('#fon-user-menu').removeClass("hide");
  });

  // add slideDown animation to dropdown
  $(".dropdown-pers").on("show.bs.dropdown", function () {
    dropdownOpenAnimation(this, "#adminIcon", ".dropdown-pers");
  });

  // add slideUp animation to dropdown
  $(".dropdown-pers").on("hide.bs.dropdown", function (e) {
    dropdownCloseAnimation(this, "#adminIcon", ".dropdown-pers");
  });

  // add slideDown animation to dropdown-messages
  $(".dropdown-messages").on("show.bs.dropdown", function () {
    dropdownOpenAnimation(this, "#messagesChevron", ".dropdown-messages");
  });

  // add slideUp animation to dropdown-messages
  $(".dropdown-messages").on("hide.bs.dropdown", function (e) {
    dropdownCloseAnimation(this, "#messagesChevron", ".dropdown-messages");
  });

  $('#more-antraege').on('click', function (e) {
	e.preventDefault();
    showMoreAntraege();
  });

  $('#toTopBtn').on('click', toTopFunction);

  $('.ausgehende-tab').on('click', function (e) {
    localStorage.setItem('focus-outbox', 'true');
  });

  $('.eingehende-tab, .left-fonmenu').on('click', function (e) {
    localStorage.removeItem('focus-outbox');
  });

  if (localStorage.getItem('focus-outbox') === "true") {
    $('.ausgehende-tab').tab('show');
  }

  // for small and medium screens remove status labels
  let width = $(window).width();
  if (width <= thresholdWidth) {
    hideAntraegeStatusLabels();
  }
  $(window).on('resize', function () {
    if ($(this).width() != width) {
      width = $(this).width();
      if (width <= thresholdWidth) {
        hideAntraegeStatusLabels();
      } else {
        showAntraegeStatusLabels();
      }
    }
  });

  // country selections containing austria
  $('.oesterreich-select').each(function () {
    const austria = $(this).find(`option[value='A']`);
    if (austria.index() != 1) {
      $(this).find(`option[value='']`).after(austria);
    }
    const delimiter = $(this).find(`option[class='option-separation']`);
    if (delimiter.length == 0) {
      austria.after(`<option class='option-separation' disabled='disabled'>--------------</option>`);
    } else {
      austria.after(delimiter);
    }
  });

  if ($('#fon-perror').length) {
    $('.show-more').hide();
    $('.collapsable-block').show();
  }
  $(`input[type='submit']`, '.l1-form').on('touchend', function() {
	  $(this).closest('form').submit(); // for Safari
  });
});

// hide status labels in dashboard on small screens
function hideAntraegeStatusLabels() {
  $(".antraege-status-th").addClass("displayNone");
  $(".antraege-status-td").addClass("displayNone");
  $(".antraege-description-th").attr("width", "70%");
}

function showAntraegeStatusLabels() {
  $(".antraege-status-th").removeClass("displayNone");
  $(".antraege-status-td").removeClass("displayNone");
  $(".antraege-description-th").attr("width", "40%");
} // handles sonstige Antraege and Familienbeihilfe Bescheide

function submitForm (params) {
  // In case of page 'Antraege' also pass the url of the given application
  if (params.form === 'antraege-form') {
    document.getElementById(params.form).action = params.url;

    if (params.url.indexOf('VERF34') !== -1) {
      document.getElementById('stnr').name = "stnr_ausw";
    }

    // check if submitted form is part of Selbstbemessungsgrundlage
    if ((params.url.indexOf('buchungSbAusw') !== -1) ||
      (params.url.indexOf('zahlungSbAusw') !== -1) ||
      (params.url.indexOf('berichtigungSbAusw') !== -1)) {
      document.getElementById('stnr').name = "fastnr";
    }
  }

  // if more than one Steuernummer, determine user selection
  var stnr;
  if (params.stnr === undefined) {
    stnr = document.getElementById(params.id).value;
  } else {
    stnr = params.stnr;
  }

  document.getElementById('stnr').value = stnr;
  document.getElementById(params.form).submit();
}

window.submitForm = submitForm;

function showMoreAntraege () {
  var antraege = $('.antraege .area .antraege-group.additional');

  if (antraege.hasClass('hide')) {
    $('.antraege .more div:first-child').html(`<a href="#">Weniger Anträge anzeigen</a>`);
  } else {
    $('.antraege .more div:last-child').html(`<a href="#">Weitere Anträge anzeigen</a>`);
  }

  antraege.toggleClass("hide");
  $('.antraege .more').toggleClass("open");
  $('.antraege .more i').toggleClass("fa-chevron-down");
  $('.antraege .more i').toggleClass("fa-chevron-up");
  $(".antraege .more div:first-child").before($(".antraege .more div:last-child"));
}

// Animation for options dropdown in main-navigation
function dropdownOpenAnimation (context, iconID, dropdownClass) {
  $(dropdownClass).addClass("keep-open");
  $(iconID).toggleClass("fa-chevron-down fa-chevron-up");
  $(context)
    .find(".dropdown-menu")
    .first()
    .stop(true, true)
    .slideDown();
  $("nav").removeClass("search-open");
}

// Animation for options dropdown in main-navigation
function dropdownCloseAnimation (context, iconID, dropdownClass) {
  $(iconID).toggleClass("fa-chevron-down fa-chevron-up");
  $(context)
    .find(".dropdown-menu")
    .first()
    .stop(true, true)
    .slideUp(400, function () {
      $(dropdownClass).removeClass("keep-open");
      $(dropdownClass).removeClass("open");
      $(dropdownClass)
        .find(".dropdown-toggle")
        .attr("aria-expanded", "false");
    });
}

// When the user scrolls down from the top of the document, show the toTop button (scroll lenght 1x Screen)
window.onscroll = function () { scrollFunction(); };

function scrollFunction () {
  if (document.getElementById("toTopBtn") !== null) {
    if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
      $("#toTopBtn").removeClass("displayNone");
      $("#toTopBtn").addClass("displayBlock");
    } else {
      $("#toTopBtn").removeClass("displayBlock");
      $("#toTopBtn").addClass("displayNone");
    }
  }
}

// When the user clicks on the toTop button, scroll to the top of the document
function toTopFunction () {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}
